'use client'

import Image from 'next/image'
import { EPL_SHIRT_TYPES } from '@constants/epl'
import LocalizedClientLink from '@modules/common/components/localized-client-link'

export default function EPLShirtTypeCarousel() {
  return (
    <div className="max-w-screen-2xl mx-auto px-4 mt-6">
      {/* Horizontally scrollable row — matches .category-banner-carousel */}
      <div
        className="overflow-x-auto"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        <div
          className="flex"
          style={{ minWidth: 'max-content', gap: 8, padding: '4px 0 8px' }}
        >
          {EPL_SHIRT_TYPES.map((type) => (
            <LocalizedClientLink
              key={type.url}
              href={`/football-shirts/english-premier-league/${type.url}`}
              className="flex flex-col items-center flex-shrink-0 group"
              style={{ width: 90, textAlign: 'center', textDecoration: 'none' }}
            >
              {/* Circular image — matches .circular-card__image: border-radius 50%, overflow hidden */}
              <div
                style={{
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  border: '3px solid transparent',
                  overflow: 'hidden',
                  background: '#f7f7f7',
                  marginBottom: 6,
                  flexShrink: 0,
                }}
              >
                <Image
                  src={type.img}
                  alt={type.title}
                  width={80}
                  height={80}
                  className="w-full h-full object-contain"
                />
              </div>
              {/* Title — matches .circular-card__title: 14px, 400, rgb(51,51,51), center */}
              <p
                style={{
                  fontSize: 13,
                  fontWeight: 400,
                  color: 'rgb(51,51,51)',
                  textAlign: 'center',
                  lineHeight: 1.4,
                  margin: 0,
                  maxWidth: 88,
                  wordBreak: 'normal',
                  overflowWrap: 'break-word',
                }}
              >
                {type.title}
              </p>
            </LocalizedClientLink>
          ))}
        </div>
      </div>
    </div>
  )
}
